"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodServerResponse = exports.ExecuteResult = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Instance_1 = require("./Instance");
const ModificationInfo_1 = require("./ModificationInfo");
var ExecuteResult;
(function (ExecuteResult) {
    ExecuteResult[ExecuteResult["NotExecuted"] = 0] = "NotExecuted";
    ExecuteResult[ExecuteResult["OK"] = 1] = "OK";
    ExecuteResult[ExecuteResult["Cancel"] = 2] = "Cancel";
})(ExecuteResult = exports.ExecuteResult || (exports.ExecuteResult = {}));
class MethodServerResponse {
    // Methods
    constructor() {
        // Properties
        this.result = ExecuteResult.OK;
        this.modifications = undefined;
        this.readObjects = undefined;
        this.additionalInformation = {};
    }
    static fromJSON(json, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let methodServerResponseReturn = new MethodServerResponse();
            if (json["result"])
                methodServerResponseReturn.result = json["result"];
            if (json["modifications"])
                methodServerResponseReturn.modifications = yield ModificationInfo_1.ModificationInfo.fromJSON(json["modifications"], virtualFields);
            if (json["readObjects"])
                methodServerResponseReturn.readObjects = yield Instance_1.Instance.fromJSONArray(json["readObjects"], virtualFields);
            if (json["additionalInformation"])
                methodServerResponseReturn.additionalInformation = Object.assign(json["additionalInformation"], virtualFields);
            return methodServerResponseReturn;
        });
    }
}
exports.MethodServerResponse = MethodServerResponse;
